import React, { useState, useEffect, useRef } from "react";
import { Modal } from "./Modal";
// import "./AddSourceModal.css";
import { graphql, createFragmentContainer } from "react-relay";
import InlineNotification from "./InlineNotification";
import AddSubscriptionMutation from "../mutations/AddSubscriptionMutation";
import AddSmallScreenSubMutation from "../mutations/AddSmallScreenSubMutation";
import { useTheme } from "../contexts/ThemeContext";
import { commitLocalUpdate } from "react-relay";
import environment from "../Environment";
import { useMediaQuery } from "react-responsive";
import AddFolderMutation from "../mutations/AddFolderMutation";
import ButtonSelect from "../components/ButtonSelect";
import { Add20 } from "@carbon/icons-react";
import AnalysePageContainerTopWrapper from "../AnalysePageContainerTopWrapper";

function AnalyseModal(props) {
    const [isNewFolder, setIsNewFolder] = useState(false);

    const isSmallScreen = useMediaQuery({
        query: "(max-width: 900px)",
    });

    const [style, setStyle] = useState({
        modal: {
            width: "70vw",
            height: "70vh",
        },
        newTextBox: {
            display: "block",
        },
    });

    const theme = useTheme();


    function onCancelClick(e) {
        e.preventDefault();
        props.setIsModalActive(false);
    }

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode == 27) {
                props.setIsModalActive(false);
            }
        };

        window.addEventListener("keydown", handleEsc);
        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, []);




    return (
        <div className="analyse-modal-container"
            style={{overflow: "scroll", border: "1px"}}
        >
            <Modal
                style={style}
                title={"Add Source"}
                isModalActive={props.isModalActive}
                setIsModalActive={props.setIsModalActive}
            >
                <AnalysePageContainerTopWrapper />
            </Modal>
        </div>
    );
}

export default AnalyseModal;
